import React from "react";
import { Box, Button, Divider } from "@material-ui/core";

// Grouped as Word groups them: rows, columns, cells, then the table itself.
const GROUPS = [
  [
    { label: "Row above", command: "addRowBefore" },
    { label: "Row below", command: "addRowAfter" },
    { label: "Delete row", command: "deleteRow" },
  ],
  [
    { label: "Column left", command: "addColumnBefore" },
    { label: "Column right", command: "addColumnAfter" },
    { label: "Delete column", command: "deleteColumn" },
  ],
  [
    { label: "Merge cells", command: "mergeCells" },
    { label: "Split cell", command: "splitCell" },
    { label: "Header row", command: "toggleHeaderRow" },
  ],
  [{ label: "Delete table", command: "deleteTable" }],
];

/**
 * The row of table commands shown under the toolbar while the caret is in a
 * table. Toolbar.js decides when to render it.
 */
export default function TableContextStrip({ editor }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      className="rte__table-strip"
    >
      {GROUPS.map((group, groupIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={groupIndex}>
          {groupIndex > 0 && (
            <Divider
              orientation="vertical"
              flexItem
              className="rte__toolbar-sep"
            />
          )}
          {group.map(({ label, command }) => (
            <Button
              key={command}
              size="small"
              // Merge is only possible over a multi-cell selection and split
              // only on a merged cell; can() dry-runs the command to tell.
              disabled={!editor.can()[command]()}
              // Without this the mousedown blurs the editor and the command
              // runs against a collapsed selection outside the table.
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => editor.chain().focus()[command]().run()}
            >
              {label}
            </Button>
          ))}
        </React.Fragment>
      ))}
    </Box>
  );
}
